/* eslint-disable array-callback-return */
import React, { forwardRef, Fragment, useRef, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Button, Table, TableBody, TableHead, TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Print } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";

/*------------- Function Component to be called by ToPrintPageBookTestDate-----------*/
const ComponentToPrint = forwardRef((props, ref) => {
    const { dataToPrint } = props;
    const alltestresvlist = useSelector((state) => state.testresvinfostate.alltestresvarr);
    const seatstate = useSelector(state => state.seatstate.seatstatus);
    //console.log('alltestresvlist ---> ', alltestresvlist.data, 'engdate : ', dataToPrint.engdatearr);

    /*--------------------------------- TestTypeCheckFunc -------------------*/
    const TestTypeCheckFunc = (reqarr, labroom) => {
        let newreqarr = reqarr.filter(e => e.testlabroom === labroom);
        let typecheckarr = newreqarr.reduce((a, b) => {
            a.push(b.testtype);
            return a;
        }, []);

        const typearr = ['รอเลือกรูปแบบการสอบ', 'Random Test', 'Adaptive Test', 'คละรูปแบบการสอบ'];
        if (typecheckarr.length !== 0) {
            if (typecheckarr.every(elm => elm === typecheckarr[0])) {
                return typearr[typecheckarr[0]];
            } else {
                return typearr[3];
            }
        } else {
            return typearr[0];
        }
    }

    /*--------------------------------- CriteriaCheckFunc -------------------*/
    const CriteriaCheckFunc = (reqarr, labroom) => {
        let newreqarr = reqarr.filter(e => e.testlabroom === labroom);
        let criteriacheckarr = newreqarr.reduce((a, b) => {
            a.push(b.showscoringcriteria);
            return a;
        }, []);

        const criteriaarr = [
            'รอเลือกการแสดงเกณฑ์การผ่าน', 'ไม่แสดงเกณฑ์การผ่าน', 'แสดงเกณฑ์การผ่าน', 'คละการแสดงเกณฑ์การผ่าน'
        ];
        if (criteriacheckarr.length !== 0) {
            if (criteriacheckarr.every(elm => elm === criteriacheckarr[0])) {
                return criteriaarr[criteriacheckarr[0] + 1];
            } else {
                return criteriaarr[3];
            }
        } else {
            return criteriaarr[0];
        }
    }
    /*--------------------------------- TmpLabroomInfoFunc -------------------*/
    const TmpLabroomInfoFunc = (date, time) => {
        let reqdata = alltestresvlist.data
            .filter(elm => elm['tbtestreservation.testreqdate'] === date)
            .filter(elm => elm['tbtestreservation.testreqtime'].split(':')[0]
                .concat(elm['tbtestreservation.testreqtime'].split(':')[1]) === time.split('-')[0]);

        let labroominfo = [
            { 'lab1': seatstate.data?.totalseat?.lab1, 'invigilator': null, 'testtype': null, 'criteria': null },
            { 'lab2': seatstate.data?.totalseat?.lab2, 'invigilator': null, 'testtype': null, 'criteria': null },
            { 'lab3': seatstate.data?.totalseat?.lab3, 'invigilator': null, 'testtype': null, 'criteria': null },
            { 'lab6': seatstate.data?.totalseat?.lab6, 'invigilator': null, 'testtype': null, 'criteria': null },
        ];

        let seatcount = [0, 0, 0, 0,];
        reqdata.map(lb => {
            //console.log('lb------->', lb);
            switch (lb['testlabroom']) {
                case 'lab1':
                    labroominfo[0]['lab1'] = seatstate.data?.totalseat?.lab1 - (++seatcount[0]);
                    labroominfo[0]['invigilator'] = dataToPrint.invlist.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
                    labroominfo[0]['testtype'] = TestTypeCheckFunc(reqdata, 'lab1');
                    labroominfo[0]['criteria'] = CriteriaCheckFunc(reqdata, 'lab1');
                    break;
                case 'lab2':
                    labroominfo[1]['lab2'] = seatstate.data?.totalseat?.lab2 - (++seatcount[1]);
                    labroominfo[1]['invigilator'] = dataToPrint?.invlist?.filter(elm => elm?.pers_id === lb['invigilator'])[0]['name'] ?? null;
                    labroominfo[1]['testtype'] = TestTypeCheckFunc(reqdata, 'lab2');
                    labroominfo[1]['criteria'] = CriteriaCheckFunc(reqdata, 'lab2');
                    break;
                case 'lab3':
                    labroominfo[2]['lab3'] = seatstate.data?.totalseat?.lab3 - (++seatcount[2]);
                    labroominfo[2]['invigilator'] = dataToPrint.invlist.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
                    labroominfo[2]['testtype'] = TestTypeCheckFunc(reqdata, 'lab3');
                    labroominfo[2]['criteria'] = CriteriaCheckFunc(reqdata, 'lab3');
                    break;
                case 'lab6':
                    labroominfo[3]['lab6'] = seatstate.data?.totalseat?.lab6 - (++seatcount[3]);
                    labroominfo[3]['invigilator'] = dataToPrint.invlist.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
                    labroominfo[3]['testtype'] = TestTypeCheckFunc(reqdata, 'lab6');
                    labroominfo[3]['criteria'] = CriteriaCheckFunc(reqdata, 'lab6');
                    break;
                default:
            }
        });
        //console.log('labroominfo ---> ', date, ' : ', time, ' : ', labroominfo);
        return labroominfo;
    }

    /*------------------- RETURN ---------------------------*/
    return (
        <div ref={ref} >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={10} align='center'>
                            <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                รายงานการจัดการทดสอบ ห้องสอบ {dataToPrint?.labroom?.toUpperCase()}
                            </div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                วันที่
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                เวลา
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                จำนวนที่นั่งคงเหลือ
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                ผู้คุมสอบ
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                รูปแบบการทดสอบ
                            </div>
                        </TableCell>
                        <TableCell align='center'>
                            <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                                แสดงเกณฑ์การผ่าน
                            </div>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        dataToPrint.thdatearr.reduce((a, b) => [...a, ...b], []).map((date, idx) => {
                            return (
                                ['0900 - 1000', '1030 - 1130', '1330 - 1430'].map((elm, i) => {
                                    return (
                                        <TableRow key={i}>
                                            {
                                                i === 0 && <TableCell rowSpan={3} style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                    {date}
                                                </TableCell>
                                            }
                                            <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                {elm}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                { // seat remaining 
                                                    dataToPrint?.engdatearr?.map(
                                                        e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                                                    )[idx]
                                                    [dataToPrint?.labroom !== 'lab6' ?
                                                        parseInt(dataToPrint?.labroom?.slice(-1)) - 1 : 3
                                                    ][dataToPrint?.labroom]
                                                }
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                { // invigilator
                                                    dataToPrint?.engdatearr?.map(
                                                        e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                                                    )[idx]
                                                    [dataToPrint?.labroom !== 'lab6' ?
                                                        parseInt(dataToPrint?.labroom?.slice(-1)) - 1 : 3
                                                    ]['invigilator'] ?? '--'//'รอกำหนดผู้คุมสอบ'
                                                }
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                { // test type
                                                    dataToPrint?.engdatearr?.map(
                                                        e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                                                    )[idx]
                                                    [dataToPrint?.labroom !== 'lab6' ?
                                                        parseInt(dataToPrint?.labroom?.slice(-1)) - 1 : 3
                                                    ]['testtype'] ?? '--'//'รอกำหนดประเภทแบบทดสอบ'
                                                }
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                                                { // criteria
                                                    dataToPrint?.engdatearr?.map(
                                                        e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                                                    )[idx]
                                                    [dataToPrint?.labroom !== 'lab6' ?
                                                        parseInt(dataToPrint?.labroom?.slice(-1)) - 1 : 3
                                                    ]['criteria'] ?? '--'//'รอเลือกการแสดงเกณฑ์การผ่าน'
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })// end time map
                            )
                        }) // end date map
                    }
                </TableBody>
            </Table>
        </div >
    );
});

/*------------- Function Component to be called as child component -----------*/
const ToPrintPageLabroomManagement = (props) => {
    const { toprint } = props;
    const componentRef = useRef();

    const marginTop = '1cm';
    const marginRight = '0.5cm';
    const marginBottom = '1cm';
    const marginLeft = '0.5cm';

    const getPageMargin = () => {
        return (`
            @page {
                size: A4 landscape;
                margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
            }
        `);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: getPageMargin()
    });

    return (
        <Fragment>
            <div style={{ display: 'none' }}>
                <ComponentToPrint ref={componentRef} dataToPrint={toprint} />
            </div>
            <Button
                variant={'contained'}
                endIcon={<Print />}
                onClick={
                    handlePrint
                }
                sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    width: 200, padding: 1, margin: 2
                }}
            >
                พิมพ์
            </Button>
        </Fragment>

    );
}

export default ToPrintPageLabroomManagement;